module.exports = __webpack_public_path__ + "img/Barra.8061ad6d.png";